import { render, staticRenderFns } from "./HomeEventList.vue?vue&type=template&id=2d19654c&scoped=true"
import script from "./HomeEventList.vue?vue&type=script&lang=js"
export * from "./HomeEventList.vue?vue&type=script&lang=js"
import style0 from "./HomeEventList.vue?vue&type=style&index=0&id=2d19654c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19654c",
  null
  
)

export default component.exports